// extracted by mini-css-extract-plugin
module.exports = {"tk_blob":"blobz_tk_blob__Ztxfm","blob-turn":"blobz_blob-turn__Vkn2R","blob-skew":"blobz_blob-skew__Rh6FI","blob-scale":"blobz_blob-scale__dj64d"};